import { Args, BaseService } from './BaseService';
import { resources } from '../resources';
import { AxiosPromise } from 'axios';
import { WorkplaceHandoverConfigRequest } from '../models/invitation/WorkplaceHandoverConfigRequest';
import { UploadWorkplaceHandoverDocument } from '../models/invitation/UploadWorkplaceHandoverDocument';

export class WorkplaceHandoverService extends BaseService {
  public previewWorkplaceHandover(args?: Args): AxiosPromise<Blob> {
    return this.get<Blob>(resources.previewWorkplaceHandover, args, { responseType: 'blob' });
  }

  public updateWorkplaceHandover(invitationId: string, data: WorkplaceHandoverConfigRequest): AxiosPromise<void> {
    return this.put<void>(resources.updateWorkplaceHandover, data, { invitationId });
  }

  public exportWorkplaceHandover(invitationId: string, disableFooterNames: boolean): AxiosPromise<Blob> {
    return this.get<Blob>(resources.exportWorkplaceHandover, { invitationId, disableFooterNames }, { responseType: 'blob' });
  }

  public uploadWorkplaceHandoverDocument(invitationId: string, data: UploadWorkplaceHandoverDocument): AxiosPromise<void> {
    return this.post<void>(resources.uploadWorkplaceHandoverDocument, data, { invitationId });
  }

  public uploadSignatures(invitationId: string, data: FormData): AxiosPromise<void> {
    return this.put<void>(resources.uploadSignatures, data, { invitationId }, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}